// extracted by mini-css-extract-plugin
export default {"zoomModal":"u4-z","image":"v4-z","button":"w4-z","isOverlayShown":"x4-z"};